import {
  EstimateModel,
  EstimationResultModel,
  PlaceModel,
} from "../store/features/estimateSlice";

import { parsePhoneNumber } from "libphonenumber-js";
import { getCategoryLookup } from "../services/categoryService";
import { CategoryLookupModel } from "../store/features/categorySlice";
import { CallbackModel } from "../store/features/callbackSlice";

export interface ResponseModel<T> {
  message: string;
  result: T;
}

export class CategoryModel {
  id?: string;
  name?: string;

  constructor(categoryLookupModel?: CategoryLookupModel) {
    if (categoryLookupModel != null) {
      this.id = categoryLookupModel.key;
      const categoryName = JSON.parse(categoryLookupModel.value);
      this.name = categoryName["en-AU"];
    }
  }
}

export class CallbackAPIModel {
  name: string;
  phoneNumber?: string;
  preferredDate?: string;
  preferredTime?: string;
  category?: string;
  email: string;
  estimateResult?: EstimationResultModel;

  constructor(
    callback: CallbackModel,
    estimate: EstimateModel,
    estimateResult?: EstimationResultModel
  ) {
    this.name = estimate.name;
    this.phoneNumber = estimate.phoneNumber.number;
    this.preferredDate = callback.preferredDate;
    this.preferredTime = callback.preferredTime;
    this.category = estimate.businessCategory?.value;
    this.email = estimate.email;
    this.estimateResult = estimateResult;
  }
}

export class EstimateAPIModel {
  id?: string;
  name?: string;
  email?: string;
  phoneNumber?: string;
  businessName?: string;
  category?: CategoryModel;
  town?: PlaceModel;
  selectedTier?: number;
  results?: EstimationResultModel[];

  constructor(estimate?: EstimateModel, result?: EstimationResultModel[]) {
    if (estimate != null) {
      this.name = estimate.name;
      this.email = estimate.email;
      this.phoneNumber = `+${estimate.phoneNumber.prefix?.phone} ${estimate.phoneNumber.number}`;
      this.businessName = estimate.businessName;
      this.category = new CategoryModel(estimate.businessCategory || undefined);
      this.town = estimate.town;
      this.selectedTier = estimate.tier;

      this.results = result;
    }
  }

  parseEstimateAPI(estimate: EstimateAPIModel) {
    this.id = estimate.id;
    this.name = estimate.name;
    this.email = estimate.email;
    this.phoneNumber = estimate.phoneNumber;
    this.businessName = estimate.businessName;
    this.category = estimate.category;
    this.town = estimate.town;
    this.selectedTier = estimate.selectedTier;
    this.results = estimate.results;
  }

  async getEstimate(baseModel: EstimateModel): Promise<EstimateModel> {
    const result = await getCategoryLookup(this.category?.id || "");

    return {
      name: this.name || baseModel.name,
      email: this.email || baseModel.email,
      businessName: this.businessName || baseModel.businessName,
      phoneNumber: {
        prefix: baseModel.phoneNumber.prefix,
        number: parsePhoneNumber(
          this.phoneNumber || "",
          baseModel.phoneNumber.prefix?.code
        ).formatNational(),
      },
      businessCategory: result != null ? result[0] : null,
      town: this.town,
      tier: this.selectedTier || baseModel.tier,
    };
  }
}
